// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../../../node_modules/rescript/lib/es6/list.js";
import * as $$String from "../../../../../../../../node_modules/rescript/lib/es6/string.js";
import * as Caml_format from "../../../../../../../../node_modules/rescript/lib/es6/caml_format.js";
import * as ListUtils$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/utils/ListUtils.bs.js";
import * as CurrencyMajorMinorMapper from "../../../../../../../library/data-source/country-currency/CurrencyMajorMinorMapper.bs.js";

function getZoneDescription(zone_id, zone_data) {
  return List.find((function (zone) {
                return Caml_format.caml_int_of_string(zone_id) === zone.id;
              }), zone_data).description;
}

function getZoneSelectDisplayData(zones, zone_data) {
  var displayStr = ListUtils$Catalyst.toString(zones, (function (c) {
          return getZoneDescription(c, zone_data);
        }), undefined, undefined);
  if (displayStr.length > 30) {
    return $$String.sub(displayStr, 0, 30) + "...";
  } else {
    return displayStr;
  }
}

function zonesToCheckBoxItems(zones) {
  return List.map((function (z) {
                return {
                        key: String(z.id),
                        value: String(z.id),
                        text: z.description
                      };
              }), zones);
}

var ZoneUtils = {
  getZoneDescription: getZoneDescription,
  getZoneSelectDisplayData: getZoneSelectDisplayData,
  zonesToCheckBoxItems: zonesToCheckBoxItems
};

function getClusterDescription(cluster_id, cluster_data) {
  return List.find((function (cluster) {
                return Caml_format.caml_int_of_string(cluster_id) === cluster.id;
              }), cluster_data).description;
}

function getClusterSelectDisplayData(clusters, cluster_data) {
  var displayStr = ListUtils$Catalyst.toString(clusters, (function (c) {
          return getClusterDescription(c, cluster_data);
        }), undefined, undefined);
  if (displayStr.length > 30) {
    return $$String.sub(displayStr, 0, 30) + "...";
  } else {
    return displayStr;
  }
}

function clustersToCheckBoxItems(clusters) {
  return List.map((function (z) {
                return {
                        key: String(z.id),
                        value: String(z.id),
                        text: z.description
                      };
              }), clusters);
}

function clustersToCheckBoxItemsForSelectedZone(clusters, zone_id) {
  if (zone_id !== undefined) {
    return List.map((function (z) {
                  return {
                          key: String(z.id),
                          value: String(z.id),
                          text: z.description
                        };
                }), List.filter(function (cluster) {
                      return cluster.zone_id === Caml_format.caml_int_of_string(zone_id);
                    })(clusters));
  } else {
    return /* [] */0;
  }
}

var ClusterUtils = {
  getClusterDescription: getClusterDescription,
  getClusterSelectDisplayData: getClusterSelectDisplayData,
  clustersToCheckBoxItems: clustersToCheckBoxItems,
  clustersToCheckBoxItemsForSelectedZone: clustersToCheckBoxItemsForSelectedZone
};

var RepeatDays = {
  daysOptions: {
    hd: {
      key: "0",
      value: "sunday",
      text: "Sunday"
    },
    tl: {
      hd: {
        key: "1",
        value: "monday",
        text: "Monday"
      },
      tl: {
        hd: {
          key: "2",
          value: "tuesday",
          text: "Tuesday"
        },
        tl: {
          hd: {
            key: "3",
            value: "wednesday",
            text: "Wednesday"
          },
          tl: {
            hd: {
              key: "4",
              value: "thursday",
              text: "Thursday"
            },
            tl: {
              hd: {
                key: "5",
                value: "friday",
                text: "Friday"
              },
              tl: {
                hd: {
                  key: "6",
                  value: "saturday",
                  text: "Saturday"
                },
                tl: /* [] */0
              }
            }
          }
        }
      }
    }
  }
};

var TestPopulation = {
  populationOptions: {
    hd: {
      key: "0",
      value: "0",
      text: "0"
    },
    tl: {
      hd: {
        key: "1",
        value: "1",
        text: "1"
      },
      tl: {
        hd: {
          key: "2",
          value: "2",
          text: "2"
        },
        tl: {
          hd: {
            key: "3",
            value: "3",
            text: "3"
          },
          tl: {
            hd: {
              key: "4",
              value: "4",
              text: "4"
            },
            tl: {
              hd: {
                key: "5",
                value: "5",
                text: "5"
              },
              tl: {
                hd: {
                  key: "6",
                  value: "6",
                  text: "6"
                },
                tl: {
                  hd: {
                    key: "7",
                    value: "7",
                    text: "7"
                  },
                  tl: {
                    hd: {
                      key: "8",
                      value: "8",
                      text: "8"
                    },
                    tl: {
                      hd: {
                        key: "9",
                        value: "9",
                        text: "9"
                      },
                      tl: /* [] */0
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

function toCorPricingSlab(slabs) {
  return List.map((function (s) {
                return {
                        slab_km: s.slab_km,
                        price_per_min: CurrencyMajorMinorMapper.currencyToBase(s.price_per_min),
                        price_per_km: CurrencyMajorMinorMapper.currencyToBase(s.price_per_km)
                      };
              }), slabs);
}

export {
  ZoneUtils ,
  ClusterUtils ,
  RepeatDays ,
  TestPopulation ,
  toCorPricingSlab ,
  
}
/* No side effect */
